var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStroke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 8,
    viewBox: "0 0 83 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.0906 4.31257L81.4637 4.5467L81.8149 5.88726C80.6934 6.18558 79.8249 6.55943 78.6203 6.66516C57.2959 8.49663 34.4083 4.53538 12.9027 5.89859C9.94216 6.0874 5.33517 7.25048 2.68804 7.05411C2.34063 7.02768 1.97056 7.07676 1.63447 6.96348C0.739509 6.66138 -0.521748 3.11929 1.60426 2.52265C3.87755 1.88824 8.8395 1.56726 11.396 1.36335C32.0179 -0.260427 53.5953 2.3867 74.4702 2.12992C76.9172 2.09971 81.6828 0.593002 82.0906 4.30503V4.31257Z",
    fill: "#F4C006"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroke);
export default __webpack_public_path__ + "static/media/stroke.1ae0111df6e782393958f3358bdcada5.svg";
export { ForwardRef as ReactComponent };